import { render, staticRenderFns } from "./AlertRelatedBinaries.vue?vue&type=template&id=106c58d2&scoped=true&"
import script from "./AlertRelatedBinaries.vue?vue&type=script&lang=js&"
export * from "./AlertRelatedBinaries.vue?vue&type=script&lang=js&"
import style0 from "./AlertRelatedBinaries.vue?vue&type=style&index=0&id=106c58d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106c58d2",
  null
  
)

export default component.exports